import fund_meta, {
  fund_symbols,
  type FundSymbol,
  simulated_fund_symbols,
  type SimulatedFundSymbol,
} from '@repo/cms/data/fission/fund_meta'

import type {
  TokenImageSlug,
  TokenRenderType,
} from '../../../components/TokenRender'

export {
  fund_symbols,
  type FundSymbol,
  simulated_fund_symbols,
  type SimulatedFundSymbol,
}

export const all_fund_symbols = [
  ...simulated_fund_symbols,
  ...fund_symbols,
] as const
export type AllFundSymbol = FundSymbol | SimulatedFundSymbol

export function isActiveFund(symbol: string) {
  return fund_symbols.includes(symbol as FundSymbol)
}
export type ProductSymbol = FundSymbol

export const priced_symbols = [...fund_symbols] as const
export type PricedSymbol = (typeof priced_symbols)[number]
export const portfolio_symbols = priced_symbols
export type PortfolioSymbol = PricedSymbol

export const other_symbols = ['USDC'] as const
export type OtherSymbol = (typeof other_symbols)[number]

export const redeemable_symbols = [
  'ACRED',
  'ACRDX',
  'FACRED',
  'FACRDX',
  'JAAA',
  'FJAAA',
  'HLSCOPE',
  'FHLSCOPE',
] as const
export type RedeemableSymbol = (typeof redeemable_symbols)[number]

export const swapable_symbols = ['USDC', ...fund_symbols] as const
export type SwapableSymbol = (typeof addressable_symbols)[number]

export const addressable_symbols = [...fund_symbols, ...other_symbols] as const
export type AddressableSymbol = (typeof addressable_symbols)[number]

export const all_token_symbols = [
  ...addressable_symbols,
  ...simulated_fund_symbols,
  ...redeemable_symbols,
] as const

export type JustTokenSymbol = (typeof all_token_symbols)[number]
// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
export type TokenSymbol = JustTokenSymbol | string

export type TokenName = {
  symbol: TokenSymbol
  image_slug: TokenImageSlug
  type: TokenRenderType
  short_name: string
  name: string
}

export function getTokenNames(symbol: TokenSymbol): TokenName | undefined {
  return names[symbol as JustTokenSymbol]
}

export function isAddressableToken(symbol: TokenSymbol) {
  return addressable_symbols.includes(symbol as AddressableSymbol)
}

export function toAddressableToken(symbol: TokenSymbol) {
  if (!isAddressableToken(symbol)) {
    console.error(`Invalid token symbol: ${symbol}`)
  }
  return symbol as AddressableSymbol
}

export function getLPName(symbol: [FundSymbol | 'USDC', FundSymbol | 'USDC']) {
  const fund_symbol = symbol[0] == 'USDC' ? symbol[1] : symbol[0]

  return {
    name: `LP Token`,
    short_name: `USDC ⇄ ${fund_symbol}`,
  }
}

const names: Partial<Record<JustTokenSymbol, TokenName>> = {
  USDC: {
    name: 'USD Coin',
    short_name: 'USDC',
    symbol: 'USDC',
    image_slug: 'usdc',
    type: 'token',
  },
  XVC: {
    name: fund_meta.XVC.name,
    short_name: fund_meta.XVC.short_name,
    symbol: fund_meta.XVC.symbol,
    image_slug: 'token_x',
    type: 'fund',
  },
  XPE: {
    name: fund_meta.XPE.name,
    short_name: fund_meta.XPE.short_name,
    symbol: fund_meta.XPE.symbol,
    image_slug: 'token_x',
    type: 'fund',
  },
  XUC: {
    name: fund_meta.XUC.name,
    short_name: fund_meta.XUC.short_name,
    symbol: fund_meta.XUC.symbol,
    image_slug: 'token_x',
    type: 'fund',
  },
}
